<template>
    <div class="content">
        <van-nav-bar left-arrow title="用户风险评测" @click-left="goableBack()" :z-index="10"></van-nav-bar>

        <van-cell>
            <div class="title">
                <span>您还未进行风险评测</span>
            </div>
            <div class="desc">
                <span>根据相关法规,买入前先进行测评,以便了解自身的风向承受能力，作出理性投资决策</span>
            </div>

            <van-button class="start" size="large" type="danger" @click="$router.push({name:'questions'})">开始评测</van-button>
        </van-cell>
    </div>
</template>

<script>
    import * as RisksApi from "@/api/risks";
    import storage from "@/utils/storage";
    import {
        NavBar,
        Col,
        Icon,
        Cell,
        Button,
        Toast,
        Dialog
    } from "vant";

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Col.name]: Col,
            [Icon.name]: Icon,
            [Cell.name]: Cell,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [Dialog.name]: Dialog
        },
        data: () => ({

        }),
        created() {
            // 确认是否登录
            if (this._confirmLogin({mustLogin: true})) {

            }
        },
        methods: {}
    };
</script>


<style lang="less" scoped>
    .content {
        .title {
            text-align: center;
            font-size: 22px;
            margin-top: 80px;
        }

        .desc {
            font-size: 16px;
            margin-top: 30px;
            text-indent: 32px;
        }

        .start {
            margin-top: 170px;
        }
    }
</style>